import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import AudienceFilterCriteria from './AudienceFilterCriteria'
import AudienceList from './AudienceList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './AudienceAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setAudienceDashboardAudienceList } from '../../store/slice/ManufSlice';

export default function AudienceListView({setShowEdit,setAudienceId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.audienceDashboard);   

    const [filteredAudienceList, setFilteredAudienceList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { audienceDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (audienceDashboard.audienceList.length>-1){
        setFilteredAudienceList(audienceDashboard.audienceList);
        transformToCardFormat(audienceDashboard.audienceList, setCardList);
      }
    },[audienceDashboard.audienceList])

    useEffect(()=>{
          transformToCardFormat(filteredAudienceList, setCardList);
      },[filteredAudienceList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.email==='' ){
            setFilteredAudienceList(audienceDashboard.audienceList);
            transformToCardFormat(audienceDashboard.audienceList, setCardList);

        } else {
            setFilteredAudienceList(
                audienceDashboard.audienceList
                    .filter(audience=> audience.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(audience=> audience.email.toString().toUpperCase().includes(filterCriteria.email.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(audienceDashboard.filteredAudienceList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <AudienceList
                    setShowEdit={setShowEdit}
                    setAudienceId = {setAudienceId}
                    tableList={filteredAudienceList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}